import React, { createContext, useContext, useLayoutEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { matchKeys, setMatchesV2ActiveWorkspace } from '@/services/api/matchesV2';
import { useWorkspace } from './WorkspaceContext';

const MatchWorkspaceContext = createContext('');

export const MatchWorkspaceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const client = useQueryClient();
  const requested = useWorkspace().currentWorkspace?.id ?? '';
  const previous = useRef(requested);
  const [ready, setReady] = useState(requested);
  useLayoutEffect(() => {
    let active = true;
    const settle = async () => {
      const old = previous.current;
      setReady('');
      setMatchesV2ActiveWorkspace('');
      if (old && old !== requested) {
        await client.cancelQueries({ queryKey: matchKeys.root(old) });
        client.removeQueries({ queryKey: matchKeys.root(old) });
      }
      // Remove pre-migration unscoped cache entries without touching other domains.
      client.removeQueries({ predicate: query => query.queryKey[0] === 'matches' || query.queryKey[0] === 'fixtures' || query.queryKey[0] === 'wyscout-matches' });
      previous.current = requested;
      if (active) { setMatchesV2ActiveWorkspace(requested); setReady(requested); }
    };
    void settle();
    return () => { active = false; };
  }, [client, requested]);
  return <MatchWorkspaceContext.Provider value={ready === requested ? requested : ''}>{children}</MatchWorkspaceContext.Provider>;
};

export const useMatchWorkspace = (): string => useContext(MatchWorkspaceContext);
